import ProductSearchComponent from '../base/productSearchComponent';
export default class Refinements extends ProductSearchComponent {
    constructor(element) {
        super(element);
        this.refinementsCount = 0;
        this.endpoint = document.body.querySelector(this.SELECTORS.selectableItems).getAttribute('data-refinement-url').split('?')[0] || '';
        this.listenForTriggers();
        this.checkSelectedRefinements();
    }
    get SELECTORS() {
        return {
            refinementsWrapper: '.refinements--wrapper',
            selectableItems: '[data-refinement-trigger]',
            groups: '.refinement-group',
            filterTrigger: '.toolbar-cta--refinements',
            filtersActive: '.filter-active-counter'
        };
    }
    get CLASSES() {
        return {
            disabled: 'disabled',
            filterActive: 'active',
            hide: 'hide'
        };
    }
    listenForTriggers() {
        const refinementTriggers = this._el.querySelectorAll(this.SELECTORS.selectableItems);
        refinementTriggers.forEach((trigger) => {
            ['change', 'click'].forEach((ev) => {
                trigger.addEventListener(ev, async (e) => {
                    this.printMethod = 'replace';
                    this.setRefinements(e.currentTarget);
                    this.getPage(e.currentTarget);
                });
            });
        });
    }
    setRefinements(trigger) {
        let refinementUrl = trigger.getAttribute('data-refinement-url');
        let qs = this.qs.parse(refinementUrl.split('?')[1]);
        let srule = window.productSearchData.searchParams.srule;
        window.productSearchData.searchParams = qs;
        window.productSearchData.searchParams.start = 0;
        window.productSearchData.searchParams.sz = window.productSearchData.increment;
        if (srule) {
            window.productSearchData.searchParams.srule = srule;
        }
    }
    reviewDomElements(html) {
        this.updateRefinements(html.querySelector(this.SELECTORS.refinementsWrapper));
    }
    updateRefinements(htmlRefinements) {
        document.body.querySelector(this.SELECTORS.refinementsWrapper).innerHTML = htmlRefinements.innerHTML;
        this.backToInit();
    }
    updateData(html) {
        window.productSearchData.currentPage = 1;
        window.productSearchData.counter = window.productSearchData.increment;
        window.productSearchData.total = html.querySelector(this.selectors.productListWrapper).getAttribute('data-productcount');
        window.productSearchData.datalayerOffset = 1;
        let excludedKeys = ['cgid', 'start'];
        let refinementKeys = Object.assign({}, window.productSearchData.searchParams);
        excludedKeys.forEach((key) => {
            delete refinementKeys[key];
        });
        window.productSearchData.searchQs = refinementKeys;
    }
    backToInit() {
        this.refinementsCount = 0;
        this.listenForTriggers();
        this.checkSelectedRefinements();
    }
    checkSelectedRefinements() {
        const selectedRefinementDisplayNames = [...this._el.querySelectorAll(this.SELECTORS.selectableItems + ':checked')]
            .map((el) => el.getAttribute('data-refinement-displayvalue'));
        const filterTriggerCta = document.querySelector(this.SELECTORS.filterTrigger);
        const filtersActive = [...this._el.querySelectorAll(this.SELECTORS.filtersActive)];
        if (filterTriggerCta) {
            if (selectedRefinementDisplayNames.length > 0) {
                filterTriggerCta.classList.add(this.CLASSES.filterActive);
            }
            else {
                filterTriggerCta.classList.remove(this.CLASSES.filterActive);
            }
        }
        if (filtersActive && filtersActive.length > 0) {
            filtersActive.forEach((filterActive) => {
                filterActive.innerHTML = `(${selectedRefinementDisplayNames.length})`;
                if (selectedRefinementDisplayNames.length > 0) {
                    filterActive.closest('.filter-empty').classList.remove(this.CLASSES.hide);
                }
                else {
                    filterActive.closest('.filter-empty').classList.add(this.CLASSES.hide);
                }
            });
        }
    }
}
